export default "__VITE_ASSET__Bn7TPUvD__"